import React from 'react';
const GalleryElement = () => <div className="builder-gallery" style={{padding:'1rem',border:'1px dashed #ccc'}}>🎞️ Gallery (Coming Soon)</div>;
export default GalleryElement;
